import BigNumber from 'bignumber.js'
import React, { useCallback, useMemo, useState } from 'react'
import Web3 from 'web3'
import styled from 'styled-components'
import { Button, Modal, Text } from '@pancakeswap-libs/uikit'
import Input from 'components/Input'
import ModalActions from 'components/ModalActions'
import useI18n from 'hooks/useI18n'

interface ModalProps {
  token: any
  emissionPerBlock: any
  onConfirm?: (amount: string) => Promise<any>
  onDismiss?: () => void
}

const TheModal: React.FC<ModalProps> = ({ token, emissionPerBlock, onConfirm, onDismiss }) => {
  const [newValue, setNewValue] = useState(emissionPerBlock)
  const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    setNewValue(e.currentTarget.value); 
  }
  const [pendingTx, setPendingTx] = useState(false)
  const [, setRequested] = useState(false)
  const TranslateString = useI18n()

  const isValid = (input) => {
    return input && !Number.isNaN(Number(input)) && Number(input)>0;
  }

  const handleSubmit = useCallback(async () => {
    try {
      setRequested(true)
      const txHash = await onConfirm(newValue);
      // user rejected tx or didn't go thru
      if (txHash) {
        setRequested(false)
      }
    } catch (e) {
      console.error(e)
    }
  }, [onConfirm, setRequested, newValue])

  return (
    <Modal title={`${TranslateString(1237,'Change Emission')} (${token.symbol}/block)`} onDismiss={onDismiss}>
      <Input placeholder={`New Emission (${token.symbol}/block)`} value={newValue} onChange={handleChange} />
      <div>
        <Announce>
          {TranslateString(1276,'Changing emission is usually not recommended, especially when there is a deposit fee. Communicate well with the community before this action!')}
        </Announce>
      </div>
      <ModalActions>
        <Button fullWidth variant="secondary" onClick={onDismiss}>
          {TranslateString(462, 'Cancel')}
        </Button>
        <Button
          fullWidth
          disabled={pendingTx || !isValid(newValue)}
          onClick={async () => {
            setPendingTx(true)
            await handleSubmit()
            setPendingTx(false)
            onDismiss()
          }}
        >
          {pendingTx ? TranslateString(488, 'Pending Confirmation') : TranslateString(464, 'Confirm')}
        </Button>
      </ModalActions>
    </Modal>
  )
}

export default TheModal

const Announce = styled.div`
  margin-top: 1em;
  color: #f41e5b;
  text-align: center;
  max-width: 470px;
`
